"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const styled_1 = require("./styled");
const _service_1 = require("~service");
const DownloadQuote = ({ token, quote }) => {
    const downloadToken = `${token}-pdf-quote`;
    const [isDownloading, setIsDownloading] = (0, ui_1.useFileDownload)(downloadToken);
    const url = _service_1.productQuoteService.useGetQuotePDFURL({}, {
        token,
        accessCode: quote.accessCode,
        downloadToken,
    });
    return ((0, jsx_runtime_1.jsxs)(styled_1.StyledQuoteButton, { href: url, download: `phishtool-enterprise-quote-${quote.reference}.pdf`, "$disabled": isDownloading, onClick: (e) => {
            if (isDownloading) {
                e.preventDefault();
            }
            else {
                setIsDownloading(true);
            }
        }, children: [(0, jsx_runtime_1.jsx)("span", { children: "Download quote" }), isDownloading ? ((0, jsx_runtime_1.jsx)(ui_1.ActivityIndicator, { size: 36 })) : ((0, jsx_runtime_1.jsx)(ui_1.Icon, { name: "cloud-download", size: { width: 52, height: 36 }, alignment: "vertical" }))] }));
};
exports.default = DownloadQuote;
